export const getOffsetTop = element => {
  let offsetTop = 0;
  let elem = element;
  while (elem) {
    offsetTop += elem.offsetTop;
    elem = elem.offsetParent;
  }
  return offsetTop;
};
